import { FACTORY_ADDRESS as V2_FACTORY_ADDRESS } from '@uniswap/v2-sdk'

import { constructSameAddressMap } from '../utils/constructSameAddressMap'
import { SupportedChainId } from './chains'

type AddressMap = { [chainId: number]: string }

// INT address
export const INT_ADDRESS: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: '0x53376356b542B8764c64411511b74dA9B9381E87',
  [SupportedChainId.RSK_MAINNET]: '0xc058522C754bb0a770C83B2C3E37c41a81AEdfE6',
}

export const V2_FACTORY_ADDRESSES: AddressMap = constructSameAddressMap(V2_FACTORY_ADDRESS)
export const V2_ROUTER_ADDRESS: AddressMap = constructSameAddressMap('0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D')

// RSK Testnet addresses
const RSK_TESTNET_CORE_FACTORY_ADDRESSES = '0xCd8615a6eD73B7B6187E8072852C4845159Df6a7'
const RSK_TESTNET_MIGRATOR_ADDRESSES = '0xeC1A0A44b8c69C08D29B2216D0D7b305340c235f'
const RSK_TESTNET_MULTICALL_ADDRESSES = '0xfD0597Ed74d427C82587835D22a4d0EF7047F80B'
const RSK_TESTNET_ROUTER_ADDRESSES = '0x0A1268677f5926cDe8604472e9eCa44E85d4363f'
const RSK_TESTNET_QUOTER_ADDRESSES = '0xF611D7e82B3a116A7027974Fb62FF53085584b57'
const RSK_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0xA7921ebad4556a5028E0df112AcdfB10428d87fd'
const RSK_TESTNET_TICK_LENS_ADDRESSES = '0x99FF6aDd4B7397FDF157726c3Cd1634C04F3713B'

// RSK Mainnet addresses
const RSK_MAINNET_CORE_FACTORY_ADDRESSES = '0x82dF0a279767021734EcE752979B34b3959C25D8'
const RSK_MAINNET_MIGRATOR_ADDRESSES = '0x13AD56421CB1b87a51c81fcCD20f6e3FC3C04128'
const RSK_MAINNET_MULTICALL_ADDRESSES = '0xFD095e82200F456B094a48A5eb529a84eED6B382'
const RSK_MAINNET_ROUTER_ADDRESSES = '0xAE9b2CbD1cab0D6D9C67E9accd329200Cd84aD81'
const RSK_MAINNET_QUOTER_ADDRESSES = '0x36D39D49f67e60fB7Dc35aEb5d297FC6cDaE86b9'
const RSK_MAINNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0xEd21EA7C1E792afF1F9BD58dD08D433ed6b7AAa2'
const RSK_MAINNET_TICK_LENS_ADDRESSES = '0x2A3ABF1CD494e7b19359B51eca9E8Cd15Fe9355B'

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_CORE_FACTORY_ADDRESSES,
}

export const V3_MIGRATOR_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_MIGRATOR_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_MIGRATOR_ADDRESSES,
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_MULTICALL_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_MULTICALL_ADDRESSES,
}

export const SWAP_ROUTER_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_ROUTER_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_ROUTER_ADDRESSES,
}

/**
 * The latest governor bravo that is currently admin of timelock
 */
export const GOVERNANCE_BRAVO_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: '0xFE077b3E2af1e6eF728248B2d0b4e7Fe3E5d2891',
  [SupportedChainId.RSK_MAINNET]: '',
}

export const TIMELOCK_ADDRESS: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: '0x66414B5543025a347aA9705B732a2e686ba219bB',
  [SupportedChainId.RSK_MAINNET]: '',
}

export const MERKLE_DISTRIBUTOR_ADDRESS: AddressMap = {
  [SupportedChainId.RSK_MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e',
}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {
  [SupportedChainId.RSK_MAINNET]: '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_QUOTER_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_QUOTER_ADDRESSES,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_MAINNET]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
}

export const SOCKS_CONTROLLER_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_MAINNET]: '0x65770b5283117639760beA3F867b69b3697a91dd',
}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.RSK_TESTNET]: RSK_TESTNET_TICK_LENS_ADDRESSES,
  [SupportedChainId.RSK_MAINNET]: RSK_MAINNET_TICK_LENS_ADDRESSES,
}
